import React, { useEffect } from 'react';
import styled from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH } from '../Grid';
import { useVideoRef } from './useVideoRef';
const Container = styled.div `
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .desktop {
    display: flex;
  }
  .mobile {
    display: none;
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    .mobile {
      display: ${({ hasMobile }) => (hasMobile ? 'flex' : 'none')};
    }
    .desktop {
      display: ${({ hasMobile }) => (hasMobile ? 'none' : 'flex')};
      // if no mobile video was passed in
      // shift the zoomed in dekstop video to focus on the right side
      mux-video {
        ::part(video) {
          --media-object-position: ${({ hasMobile }) => hasMobile ? '50% 50%' : '85%'};
        }
      }
    }
  }

  mux-video {
    position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
    ::part(video) {
      --media-object-fit: cover;
    }
  }
  :after {
    content: ' ';
    position: absolute;
    background: black;
    opacity: 30%;
    height: 100%;
    width: 100%;
  }
`;
export const BackgroundVideo = ({ desktopVideo, mobileVideo, isPlaying, }) => {
    var _a, _b, _c;
    const isMobileScreen = typeof window !== 'undefined'
        ? window.matchMedia(`(max-width: ${TWO_COLUMN_MAX_WIDTH})`).matches
        : false;
    const { ref: mobileRef, play: mobilePlay, pause: mobilePause, } = useVideoRef({
        muteOnLoad: true,
        autoplay: true,
        preload: 'auto',
    });
    const { ref: desktopRef, play: desktopPlay, pause: desktopPause, } = useVideoRef({
        muteOnLoad: true,
        autoplay: true,
        preload: 'auto',
    });
    useEffect(() => {
        var _a, _b, _c, _d;
        if (isPlaying && ((_a = mobileRef.current) === null || _a === void 0 ? void 0 : _a.paused)) {
            mobilePlay();
        }
        if (!isPlaying && !((_b = mobileRef.current) === null || _b === void 0 ? void 0 : _b.paused)) {
            mobilePause();
        }
        if (isPlaying && ((_c = desktopRef.current) === null || _c === void 0 ? void 0 : _c.paused)) {
            desktopPlay();
        }
        if (!isPlaying && !((_d = desktopRef.current) === null || _d === void 0 ? void 0 : _d.paused)) {
            desktopPause();
        }
    }, [
        desktopPause,
        desktopPlay,
        desktopRef,
        isMobileScreen,
        isPlaying,
        mobilePause,
        mobilePlay,
        mobileRef,
    ]);
    if (!desktopVideo.muxData) {
        return null;
    }
    return (React.createElement(Container, { hasMobile: ((_a = mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.muxData) === null || _a === void 0 ? void 0 : _a.playbackId) !== undefined },
        React.createElement("div", { className: "desktop" },
            React.createElement("mux-video", { ref: desktopRef, src: `https://stream.mux.com/${desktopVideo.muxData.playbackId}.m3u8#t=0.001`, poster: `https://image.mux.com/${desktopVideo.muxData.playbackId}/thumbnail.jpg?time=.001`, "metadata-video-title": desktopVideo.title, "alt-text": desktopVideo.altText, playsInline: true, preload: "auto", tabIndex: -1 })),
        mobileVideo && (React.createElement("div", { className: "mobile" },
            React.createElement("mux-video", { ref: mobileRef, src: `https://stream.mux.com/${(_b = mobileVideo.muxData) === null || _b === void 0 ? void 0 : _b.playbackId}.m3u8#t=0.001`, poster: `https://image.mux.com/${(_c = mobileVideo.muxData) === null || _c === void 0 ? void 0 : _c.playbackId}/thumbnail.jpg?time=.001`, "metadata-video-title": mobileVideo.title, "alt-text": mobileVideo.altText, playsInline: true, preload: "auto", tabIndex: -1 })))));
};
//# sourceMappingURL=BackgroundVideo.js.map